import React from 'react';
import keys from '../../common/react-query/data-keys';
import { getProjectVersion } from './project-version.api';
import { useQuery } from 'react-query';
import ProjectRenderer from './ProjectRenderer';
import { ProjectData } from './project.type';
import { CircularProgress, Stack } from '@mui/material';

interface ProjectVersionWrapperProps {
  projectId: string;
  versionId: string | null;
}

const ProjectVersionWrapper: React.FC<ProjectVersionWrapperProps> = ({ projectId, versionId }) => {
  const {
    data: projectVersion,
    isLoading,
    isError,
    error,
  } = useQuery([keys.projectVersion, projectId, versionId], () => getProjectVersion(projectId, versionId ?? ''), {
    enabled: !!versionId,
  });

  if (!versionId) {
    return (
      <Stack height={'100%'} alignItems='center' justifyContent='center'>
        No Project Version Selected!
      </Stack>
    );
  }
  if (isLoading)
    return (
      <Stack height={'100%'} alignItems='center' justifyContent='center'>
        <CircularProgress />
      </Stack>
    );

  if (isError)
    return (
      <Stack height={'100%'} alignItems='center' justifyContent='center'>
        There was an error loading the project version
      </Stack>
    );
  if (!projectVersion)
    return (
      <Stack height={'100%'} alignItems='center' justifyContent='center'>
        No Project Version Found
      </Stack>
    );

  const project: ProjectData = {
    projectSummary: projectVersion,
    projectDraws: projectVersion.drawsAndLineItems,
  };

  return (
    <ProjectRenderer
      projectId={projectId}
      project={project}
      isLoadingProjectSummary={isLoading}
      isErrorProjectSummary={isError}
      errorProjectSummary={error}
      isProjectDirty={false}
      updateProject={() => null}
      updateInitialProject={() => null}
      isProjectLoading={isLoading}
      isSaving={false}
      saveProject={() => null}
      undoChanges={() => null}
      refetchProject={() => null}
      handleCancel={() => null}
      isEditMode={false}
      setIsEditMode={() => null}
      readonly={true}
    />
  );
};

export default ProjectVersionWrapper;
